exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".statusStyle_0fddb39{display:inline-block;width:5px;height:5px;background-color:rgba(0,0,0,.25);border-radius:50%;vertical-align:middle;margin-right:5px}.box_bf8b086{position:relative}.box_bf8b086>.tip_a67be0d{position:absolute;width:246px;left:-50px;top:-45px;padding:10px 15px;line-height:20px;background-color:#5b5858;color:#fff;border-radius:10px;display:none;z-index:10000000000}.box_bf8b086>.tip_a67be0d:after{position:absolute;content:\" \";width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:6px solid #5b5858;left:50%;top:100%;transform:translateX(-50%)}.box_bf8b086:hover{cursor:pointer}.box_bf8b086:hover .tip_a67be0d{display:block}.textarea_3f22928{width:400px!important;height:200px}.textarea_3f22928 .k-textarea{height:200px!important;resize:none}.inputW_19ee90b{width:230px!important}", ""]);

// exports
exports.locals = {
	"statusStyle": "statusStyle_0fddb39",
	"box": "box_bf8b086",
	"tip": "tip_a67be0d",
	"textarea": "textarea_3f22928",
	"inputW": "inputW_19ee90b"
};